import Settings from "./Setting";
import Common from "./Common";
import Master from "./Master";
import Support from "./Support";
import PlanMaster from "./PlanMaster";
import CmsMaster from "./CmsMaster";
import CustomerMaster from "./CustomerMaster";
import ContactMaster from "./ContactMaster";
import LeadMaster from "./LeadMaster";
import AppellateMaster from "./AppellateMaster";
import NodelMaster from "./NodelMaster";
import RoleMaster from "./RoleMaster";
import Auth from "./Auth";
import TransactionMaster from "./TransactionMaster";
import InvestorDeskMaster from "./InvestorDeskMaster";
const reducers = {
  settings: Settings,
  common: Common,
  master:Master,
  support:Support,
  planMaster:PlanMaster,
  cmsMaster:CmsMaster,
  customerMaster:CustomerMaster,
  contactMaster:ContactMaster,
  leadMaster:LeadMaster,
  appellateMaster:AppellateMaster,
  nodelMaster:NodelMaster,
  roleMaster: RoleMaster,
  auth: Auth,
  transactionMaster:TransactionMaster,
  investorDeskMaster:InvestorDeskMaster,
};

export default reducers;
